import { makeStyles } from '@material-ui/core/styles'

const useEditorStyles = makeStyles(() => ({
  editorRoot: {
    position: 'relative',
    '& .ace_gutter': {
      background: 'var(--color-neutral-200)'
    },
    '& .ace_gutter-cell.ace_error': {
      background: 'color-mix(in srgb, var(--color-danger-500) 12%, transparent)',
      color: 'var(--color-danger-700)',
      fontWeight: 600
    },
    '& .ace_marker-layer .ace_error': {
      backgroundColor: 'color-mix(in srgb, var(--color-danger-500) 16%, transparent)',
      borderBottom: '1px solid var(--color-danger-500)',
      boxSizing: 'border-box'
    },
    '& .ace_tooltip': {
      background: 'var(--color-neutral-900)',
      color: 'var(--color-neutral-050)',
      border: '1px solid var(--color-neutral-700)',
      borderRadius: 6,
      boxShadow: '0 6px 20px rgba(17, 24, 39, 0.25)'
    },
    '& .ace_search': {
      background: 'var(--color-neutral-050)',
      border: '1px solid var(--color-neutral-300)',
      borderRadius: 8,
      boxShadow: '0 8px 20px rgba(15, 23, 42, 0.16)',
      padding: 6,
      right: 8,
      top: 8
    },
    '& .ace_search_field': {
      border: '1px solid var(--color-neutral-300)',
      borderRadius: 6,
      height: 23,
      padding: '0 8px',
      background: 'var(--color-neutral-050)',
      color: 'var(--color-neutral-800)'
    },
    '& .ace_search_field:focus': {
      borderColor: 'var(--color-primary-500)'
    },
    '& .ace_button, & .ace_searchbtn, & .ace_replacebtn': {
      border: '1px solid var(--color-neutral-300)',
      borderRadius: 6,
      color: 'var(--color-neutral-700)',
      background: 'var(--color-neutral-100)',
      marginLeft: 4
    },
    '& .ace_searchbtn.prev': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    '& .ace_searchbtn.next': {
      marginLeft: -1,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    '& .ace_searchbtn': {
      lineHeight: '23px',
      fontFamily: 'GothamPro-Bold, GothamPro, sans-serif',
      fontSize: '0.9em'
    },
    '& .ace_searchbtn_close': {
      position: 'absolute',
      backgroundColor: 'var(--color-neutral-300)',
      border: '1px solid var(--color-neutral-400)',
      padding: '5px',
      top: 0,
      right: 0,
      width: 18,
      height: 18,
      backgroundPosition: '1px 1px',
      '&:hover': {
        backgroundColor: 'var(--color-neutral-700)',
        borderColor: 'var(--color-neutral-600)',
        backgroundPosition: '1px -13px'
      }
    },
    '& .ace_button:hover, & .ace_searchbtn:hover, & .ace_replacebtn:hover': {
      background: 'var(--color-primary-050)',
      borderColor: 'var(--color-primary-200)'
    },
    '& .ace_button.ace_active, & .ace_searchbtn.ace_active, & .ace_replacebtn.ace_active': {
      background: 'var(--color-primary-100)',
      borderColor: 'var(--color-primary-300)',
      color: 'var(--color-primary-600)'
    },
    '& .ace_button.checked': {
      background: 'var(--color-primary-400)',
      color: 'var(--color-contrast-primary-400)',
      borderColor: 'var(--color-primary-600)'
    },
    '& .ace_search_options': {
      marginTop: 6
    },
    '& .ace_search_counter': {
      color: 'var(--color-neutral-500)'
    },
    '& .ace_search_field.ace_nomatch': {
      borderColor: 'var(--color-danger-500)',
      background: 'var(--color-danger-050)'
    }
  }
}))

export default useEditorStyles
